/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/447-appleinc': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.367 8.501c-.02-2.026 1.652-2.998 1.727-3.046-.94-1.375-2.404-1.564-2.926-1.585-1.246-.126-2.431.734-3.064.734-.631 0-1.607-.715-2.64-.696-1.358.02-2.61.79-3.31 2.006-1.411 2.448-.361 6.076 1.014 8.061.672.972 1.473 2.064 2.525 2.025 1.013-.04 1.396-.656 2.621-.656s1.569.656 2.641.635c1.09-.02 1.781-.991 2.448-1.966.772-1.128 1.089-2.219 1.108-2.275-.024-.011-2.126-.816-2.147-3.236zm-2.014-5.946c.558-.677.935-1.617.832-2.555-.804.033-1.779.536-2.356 1.212-.518.6-.971 1.557-.85 2.476.898.07 1.815-.456 2.373-1.132z"/>'
  }
})
